<template>
  <div class="intgeral-views">
    <div>
      <Nav label="商品信息"></Nav>
      <div class="table">
        <a-table
          :columns="columns"
          :data-source="tableData"
          :row-key="record => record.id"
          :loading="loading"
          class="table-content"
          bordered
        >
        </a-table>
        <div class="tbody">
          <div class="tbody-item">
            <div>配送方式</div>
            <div>
              <div class="item-text">
                回收点自取
              </div>
            </div>
          </div>

          <div class="tbody-item">
            <div>平台发布时间</div>
            <div>
              <div class="item-text">
                {{ time }}
              </div>
            </div>
          </div>
        </div>
        <div class="tbody">
          <div class="tbody-item">
            <div>商品主图</div>
            <div>
              <div class="item-image" @click="handelClick">
                <img :src="img" alt="">
              </div>
            </div>
          </div>

          <div class="tbody-item">
            <div>商品介绍</div>
            <div>
              <div class="item-text">
                {{ commonName }}
              </div>
            </div>
          </div>
        </div>
        <div class="tmain">
          <div class="tmain-item">
            <div>商品主详图</div>
            <div>
              <div
                v-for="(item,index) in imgList" :key="index+'tmain'" class="item-image"
                @click="handelClick"
              >
                <img :src="item" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <Nav label="回收点信息"></Nav>
      <div class="table">
        <a-table
          :columns="columns2"
          :data-source="tableData2"
          :row-key="record => record.id"
          :loading="loading"
          class="table-content"
          bordered
        >
          <template slot="storeImg" slot-scope="storeImg">
            <img :src="storeImg">
          </template>
        </a-table>
      </div>
    </div>
    <div class="footer">
      <a-button type="primary" small @click="goback">
        返回
      </a-button>
    </div>
    <BigImg
      :visible="visible"
      :img="img"
      :img-list="allImg"
      @handelClose="handelClose"
    />
  </div>
</template>

<script>
import BigImg from '../../components/big-img'
import Nav from '../../components/nav'
import { getGoodsDetails } from '@/api/commManage'

const columns = [
  {
    title: '商品编号',
    key: 'goodsCode',
    dataIndex: 'goodsCode',
    align: 'center'
  },
  {
    title: '标题',
    key: 'introduce',
    dataIndex: 'introduce',
    align: 'center'
  },
  {
    title: '数量',
    key: 'beginBusinessTime',
    dataIndex: 'beginBusinessTime',
    customRender: (text, record, index) => 1,
    align: 'center'
  },
  {
    title: '出售价（元）',
    key: 'buyPrice',
    dataIndex: 'buyPrice',
    align: 'center'
  },
  {
    title: '原价（元）',
    key: 'originalPprice',
    dataIndex: 'originalPprice',
    align: 'center'
  },
  { title: '商品分组',
    key: 'title',
    dataIndex: 'title',
    align: 'center'
  },
  { title: '状态',
    key: 'state',
    dataIndex: 'state',
    customRender: (text, record, index) => {
      switch (text) {
        case '0':
          return '待审核'

        case '1':
          return '待审核'
        case '2':
          return '租赁期'
        case '3':
          return '售罄'
        default:
          break
      }
    },
    align: 'center'
  }
]
const columns2 = [
  {
    title: '回收点图片',
    key: 'storeImg',
    dataIndex: 'storeImg',
    scopedSlots: { customRender: 'storeImg' },
    align: 'center'
  },

  {
    title: '回收点名称',
    key: 'name',
    dataIndex: 'name',
    align: 'center'
  },
  {
    title: '详细地址',
    key: 'address',
    dataIndex: 'address',
    align: 'center'
  },
  {
    title: '站长',
    key: 'managerName',
    dataIndex: 'managerName',
    align: 'center'
  }
]
export default {
  components: { BigImg, Nav },
  data () {
    return {
      loading: false,
      /**
       * 商品管理
       */
      columns,
      tableData: [],
      /**
       * 回收点管理
       */
      columns2,
      tableData2: [],
      // 图片展示大图
      visible: false,
      allImg: [],
      imgList: [],
      img: '',
      // 平台发布时间
      time: '',
      commonName: ''

    }
  },
  created () {
    this.getGoodsDetails()
  },
  methods: {
    // 获取详情数据
    async getGoodsDetails () {
      const res = await getGoodsDetails({ id: this.$route.query.id })
      this.tableData.push(res.result.orderDetails)
      this.tableData2.push(res.result.orderDetails)
      this.img = res.result.orderDetails.mainPath
      this.imgList = res.result.orderDetails.paths.split(',')
      this.commonName = res.result.orderDetails.introduce
      this.time = res.result.orderDetails.releaseTime
      this.allImg = this.img.split(',').concat(this.imgList)
    },
    goback () {
      this.$router.push('/catRecycling/commodityManagement/idleSecondHand')
    },
    handelClick () {
      this.visible = true
    },
    handelClose (item) {
      this.visible = item
    }
  }
}

</script>
<style lang='less' scoped>
.intgeral-views{
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 20px 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  /deep/ .ant-table-pagination{
    display: none;
  }
  /deep/ .ant-table-thead > tr > th, /deep/ .ant-table-tbody > tr > td{
    padding: 0 !important;
  }
  .tbody{
    width: 100%;
    display: flex;
    border-left: 1px solid #e8e8e8;
    border-bottom: 1px solid #e8e8e8;
    .tbody-item{
      flex: 1;
      display: flex;
      >div:nth-child(1){
        font-weight: 700;
        display: flex;
        justify-content: center;
      }

      >div{
        flex: 1;
        height: 100%;
        border-right: 1px solid #e8e8e8;
        display: flex;
        align-items: center;
      }
      .item-image,.item-text{
        padding: 10px;
        box-sizing: border-box;
      }
      .item-image{
        width: 100px;
        height: 100%;

        >img{
          width: 100%;
          height: auto;
          display: block;
          cursor: pointer;
        }
      }
    }
  }
  .tmain,.tmain-item{
    width: 100%;
    line-height: 60px;
  }
  .tmain-item{
    display: flex;
    border-left: 1px solid #e8e8e8;
    border-bottom: 1px solid #e8e8e8;
    >div{
      border-right: 1px solid #e8e8e8;
    }
    >div:nth-child(1){
      flex: 1;
      font-weight: 700;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    >div:nth-child(2){
      flex: 3;
      display: flex;
      flex-wrap: wrap;
      >div{
        margin-left: 20px;
        width: 100px;
        height: 100px;
        padding: 10px 0;
        box-sizing: border-box;
        >img{
          width: 100%;

          height: auto;
          display: block;
          cursor: pointer;
        }
      }
    }
  }
  .footer{
    display: flex;
    justify-content: flex-end;
  }

}
</style>
<style lang="stylus" scoped>
.dlMain
    width: 1
</style>
